import { useState } from 'react';
import { testimonials } from '@/mocks/homeData';

export default function TestimonialsSection() {
  const [expandedId, setExpandedId] = useState<number | null>(null);

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1.5 bg-primary-50 text-primary-600 text-xs font-semibold rounded-full mb-3">
            Testimonials
          </span>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-3">
            What People Say{' '}
            <span className="gradient-text">About Us</span>
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Hear from donors, volunteers, partners, and beneficiaries about their experience with Happy Faces.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="glass-card rounded-2xl p-5 md:p-6 hover:shadow-sm transition-all duration-300"
            >
              <div className="flex items-center gap-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                ))}
              </div>

              <p
                className={`text-foreground-600 text-sm leading-relaxed mb-4 ${
                  expandedId !== testimonial.id ? 'line-clamp-4' : ''
                }`}
              >
                &ldquo;{testimonial.quote}&rdquo;
              </p>
              {testimonial.quote.length > 180 && (
                <button
                  onClick={() => setExpandedId(expandedId === testimonial.id ? null : testimonial.id)}
                  className="text-primary-500 text-xs font-medium hover:text-primary-600 mb-3"
                >
                  {expandedId === testimonial.id ? 'Show less' : 'Read more'}
                </button>
              )}

              <div className="flex items-center gap-3 pt-3 border-t border-foreground-100">
                <div className="w-10 h-10 rounded-full bg-primary-100 flex items-center justify-center overflow-hidden">
                  <img
                    src={testimonial.imageUrl}
                    alt={testimonial.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <h5 className="text-foreground-900 text-sm font-semibold">{testimonial.name}</h5>
                  <p className="text-foreground-400 text-xs">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}